// extracted by mini-css-extract-plugin
export default {"WelcomeBannerLite":"style_WelcomeBannerLite__xcaTe","container":"style_container__YTEhu","title":"style_title__4q6G7","subTitle":"style_subTitle__EQWA7"};